namespace JupitersChoice {
    export class InitReelsCmd {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;
        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;

        execute(): void {
            const reels = this._componentManager.get('Reels');
            const grids = this._config.get('external', 'grids');
            const baseReels = grids.baseReels.reels;
            reels.build([baseReels[0], baseReels[1], baseReels[1], baseReels[1], baseReels[1], baseReels[1]], this._assetCache);
        }
    }
}